export default __webpack_public_path__ + "static/media/DSC08089.ed0fecd0.jpg";